import { render, staticRenderFns } from "./StatisticsInfoBlock.vue?vue&type=template&id=732853c5&"
import script from "./StatisticsInfoBlock.vue?vue&type=script&lang=js&"
export * from "./StatisticsInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports